module.exports = __webpack_public_path__ + "static/media/04.b568a2ac.png";